import { makeReducer } from '../../core/make-reducer';
import { makeActionCreators } from '../../core/make-action-creators';
import * as API from '../../core/api';

export const actions = {
  REQUEST: 'Dora/invites/REQUEST',
  RECEIVE: 'Dora/invites/SUCCESS',
  FAIL: 'Dora/invites/FAIL',
};

export default makeReducer({ actions });

const actionCreators = makeActionCreators({
  reducerName: 'invites',
  actions,
  requestDataCall: (store, params) => API.get('invites', params),
});

export const requestDataIfNeeded = actionCreators.requestDataIfNeeded;



// WEBPACK FOOTER //
// ./src/admin/invites/duck.js